<template>
  <div>
    <div class="section-header">
      <div class="section-headers">Assessment Library</div>
      <router-link to="/coach/assessment/creation" class="hide-at-xs">Create Custom Assessment</router-link>
    </div>
    <assessment class="small-top" v-for="assessment in assessments" :assessment="assessment" :key="assessment.id" />
  </div>
</template>

<script>
import assessment from "./assessment";
import dataStore from "@/services/api/store";

export default {
  components: { assessment },
  data() {
    return {
      assessments: []
    };
  },
  created() {
    dataStore
      .findAll("CoachAssessments", { limit: 500 }, { force: true })
      .then(r => {
        this.assessments = r;
      });
  }

}
</script>

<style>

</style>
